export const FILTERS_OR_SORT_CONSTS = {
	UPDATE_SELECTED_FILTERS: "UPDATE_SELECTED_FILTERS",
	SET_FILTER: "SET_FILTER",
	RESET_FILTERS: "RESET_FILTERS",
	DELETE_FILTER: "DELETE_FILTER",
	UPDATE_SORT_PARAMS: 'UPDATE_SORT_PARAMS'
};
